import * as React from "react";
import styled, { keyframes } from "styled-components";
import { css } from "styled-components";

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

const Spinner = styled.div<Props>`
  display: inline-block;
  position: relative;
  height: 100%;
  width: 100%;

  & > div {
    box-sizing: border-box;
    display: block;
    height: 100%;
    position: absolute;
    border: .2rem solid #fff;
    border-radius: 50%;
    animation: ${spin} 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
    border-color: ${(props) => `${props.spinnerColor} transparent transparent transparent`};
    width: 100%;
  }
  
  & > div:nth-child(1) {
    animation-delay: -0.45s;
  }
  
  & > div:nth-child(2) {
    animation-delay: -0.3s;
  }

  & > div:nth-child(3) {
    animation-delay: -0.15s;
  }
`;

export interface Props {
  spinnerColor?: string;
}

const S = (props?: Props) => (
  <Spinner spinnerColor={props?.spinnerColor ?? '#555'}>
    <div />
    <div />
    <div />
    <div />
  </Spinner>
);

export default S;
